export default function Speakers() {
  return (
    <section id="speakers" className="relative py-24 lg:py-32 border-t border-cyan-900/30">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-7">
            <div className="mono text-[11px] uppercase tracking-[0.24em] text-cyan-300">
              03 · Speakers
            </div>
            <h2 className="font-display mt-4 text-3xl lg:text-4xl font-bold text-white">
              The people shaping national cyber policy &amp; defence.
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-slate-400 leading-relaxed">
              An initial line-up of 27+ leaders from government, military,
              regulators, critical infrastructure and private sector invited.
            </p>
          </div>
        </div>

        <div className="hairline mt-10" />

        <p className="mt-10 text-xs mono uppercase tracking-widest text-slate-500">
          Full speaker line-up announced closer to event · Speaker enquiries:{" "}
          <a href="mailto:speaker@convex.events" className="text-cyan-300">
            speaker@convex.events
          </a>
        </p>
      </div>
    </section>
  );
}
